import $ from 'jquery';

function init() {

    $('.menu > .wpml-ls-item.wpml-ls-current-language').on('click', function (event) {
        let target = $(event.target).closest('.wpml-ls-item');
        if ($(this).is(target)) {
            event.preventDefault();
        }
    })

}

export default {init: init};
